import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-927a706c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "客户文件")
], -1))
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["href"]

import { computed, reactive, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import {
  addClientFile,
  getClientFiles,
  sendClientFile,
  deleteClientFile
} from '@/apis/index'
import { fileToBase64, downloadFile } from '@/utils/index'


export default /*#__PURE__*/_defineComponent({
  __name: 'clientFile',
  props: {
  dialogVisible: { type: Boolean, default: false },
  dataForm: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['update:dialogVisible'],
  setup(__props, { emit }) {

const props = __props;





const dialogVisibleFlag = computed({
  get() {
    return props.dialogVisible
  },
  set(val) {
    emit('update:dialogVisible', val)
  }
})

const state = reactive({
  loading: false,
  tableData: []
})

const customUploadFile = async ({ file }: any) => {
  try {
    state.loading = true
    const base64 = await fileToBase64(file)
    const formData = {
      param: {
        tradeAccount: props.dataForm.clientId,
        filename: file.name,
        fileBase64: base64,
        fileUpload: null
      }
    }
    const {
      data: { addClientFile: c }
    } = await addClientFile(formData)
    console.log(c)
    if (c.ok) {
      ElMessage.success('上传成功')
      getClientFileData()
    }
  } finally {
    state.loading = false
  }
}

const download = async (row: any) => {
  downloadFile(row.fileUrl, row.filename?.split('.')[0])
}

const deleteFile = async (row: any) => {
  ElMessageBox.confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    customClass: 'message-info-change',
    showClose: false,
    center: true,
    type: 'warning'
  }).then(async () => {
    try {
      state.loading = true
      const {
        data: { deleteClientFile: c }
      } = await deleteClientFile({
        param: {
          fileId: row.id
        }
      })
      if (c.ok) {
        ElMessage.success('删除成功')
        getClientFileData()
      }
    } finally {
      state.loading = false
    }
  })
}

const sendMessage = async (row: any) => {
  ElMessageBox.confirm('此操作将发送该文件至客户, 是否继续?', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    customClass: 'message-info-change',
    showClose: false,
    center: true,
    type: 'warning'
  }).then(async () => {
    const {
      data: { sendClientFile: c }
    } = await sendClientFile({
      param: {
        fileId: row.id
      }
    })
    if (c.ok) {
      ElMessage.success('发送成功')
      getClientFileData()
    }
  })
}

// 获取客户文件数据
const getClientFileData = async () => {
  try {
    state.loading = true
    const {
      data: { getClientFiles: getClientFile }
    } = await getClientFiles({
      param: {
        tradeAccount: props.dataForm.clientId
      }
    })
    state.tableData = getClientFile.data.clientFiles
  } finally {
    state.loading = false
  }
}

watch(dialogVisibleFlag, (val) => {
  if (val) {
    getClientFileData()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(dialogVisibleFlag),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(dialogVisibleFlag) ? (dialogVisibleFlag).value = $event : null)),
    title: "",
    width: "960px",
    "destroy-on-close": ""
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", null, [
        _createVNode(_component_el_upload, {
          action: "",
          accept: "*",
          "show-file-list": false,
          "http-request": customUploadFile
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              class: "upload-button",
              disabled: state.loading
            }, "上传", 8, _hoisted_2)
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          size: "small",
          "row-class-name": "table-row-hover",
          data: state.tableData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "filename",
              label: "文件"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("a", {
                  href: row.fileUrl,
                  target: "_blank"
                }, _toDisplayString(row.filename), 9, _hoisted_3)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "160px"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (download(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (deleteFile(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (sendMessage(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("发送")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, state.loading]
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})